import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';

export async function getContract(id: string) {
  return fetchWrapper(endpoint + `/v1/contract/${id}`).then((res) =>
    res.json(),
  );
}
